import { useSelector } from "react-redux";
import { RootState } from "app/store";
import { useScale } from "common/utils";
import { Score } from "features/courses/algorithm/game/scene/components";
import { PreviewTimeChip } from "./PreviewTimeChip";

// プレビュー画面上部の HUD。
// [ピース名タイトル（青バー・2 行折返し）][Score+タイム] を 1 つの縦 flex flow（gap-2）で
// 積むことで、タイトルの行数によらず間隔が常に詰まった状態を保つ。
export const PreviewSceneTitle = ({
  totalGem,
  gemScore,
  elapsedMs,
}: {
  totalGem: number;
  gemScore: number;
  elapsedMs: number;
}) => {
  const { scale } = useScale();
  const name = useSelector((state: RootState) => state.builder.name);

  return (
    <div className="flex-col-el items-center w-full absolute top-0 z-10 pointer-events-none">
      <div
        className="flex-col-el items-center gap-2 origin-top"
        style={{ marginTop: 24 * scale, transform: `scale(${scale})` }}
      >
        {name.trim() && (
          <div className="flex-col-el items-center justify-center box-border min-h-[68px] max-w-[720px] bg-[#2766ae] px-8 py-2 rounded-xl">
            <p className="title-text type-title text-white !tracking-[.2em] text-center break-words line-clamp-2">
              {name}
            </p>
          </div>
        )}

        <div className="flex-row-el items-center h-[56px] gap-2">
          {totalGem > 0 && <Score totalGem={totalGem} gemScore={gemScore} />}
          <PreviewTimeChip elapsedMs={elapsedMs} />
        </div>
      </div>
    </div>
  );
};
